import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag as solidFlag } from '@fortawesome/pro-solid-svg-icons';
import { faFlag as outlinedFlag } from '@fortawesome/pro-regular-svg-icons';
import { React } from 'Imports';
import { UserResponse } from '$Generated/api';
import classNames from 'classnames';
import { isEncompass } from '$Utilities/integrationPlatform';
import { IntegrationPartnerDataService } from '$State/IntegrationPartnerDataFreezerService';

interface VideoEventFlagButtonProps {
    videoEventId: number;
    flaggedByUsers: UserResponse[];
    showLabel?: boolean;
    onClick: (videoEventId: number) => void;
    userCanEdit: boolean;
    labelSize?: string;
    iconSize?: string;
}

const styles = require('./VideoEventFlagButton.scss') as {
    container: string;
    button: string;
    unflagged: string;
    flagged: string;
    labelGeotab: string;
    labelEncompass: string;
    disabled: string;
};

const VideoEventFlagButton = (props: VideoEventFlagButtonProps) => {
    const { flaggedByUsers } = props;
    const flaggedByCurrentUser = flaggedByUsers?.some(
        (user) => user.integrationProviderSourceId === IntegrationPartnerDataService.getState().currentUserResult.data.id,
    );
    const flaggedByOtherUsers =
        flaggedByUsers.filter(
            (user) => user.integrationProviderSourceId !== IntegrationPartnerDataService.getState().currentUserResult.data.id,
        ) || [];

    const tooltip = flaggedByCurrentUser
        ? flaggedByOtherUsers.length > 0
            ? `Flagged by you and ${flaggedByOtherUsers.length} other${flaggedByOtherUsers.length > 1 ? 's' : ''}`
            : 'Flagged by you'
        : flaggedByOtherUsers.length > 0
          ? `Flagged by ${flaggedByOtherUsers.length} ${flaggedByOtherUsers.length > 1 ? 'people' : 'person'}`
          : 'Not Flagged';

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        if (!props.userCanEdit) return;

        props.onClick(props.videoEventId);
    };

    return (
        <div className={styles.container} title={tooltip}>
            <button
                className={classNames(
                    styles.button,
                    !props.userCanEdit ? styles.disabled : flaggedByUsers.length > 0 ? styles.flagged : styles.unflagged,
                )}
                onClick={(e) => handleClick(e)}
                disabled={!props.userCanEdit}
            >
                <FontAwesomeIcon
                    icon={
                        !props.userCanEdit
                            ? flaggedByUsers.length > 0
                                ? solidFlag
                                : outlinedFlag
                            : flaggedByCurrentUser
                              ? solidFlag
                              : outlinedFlag
                    }
                    style={{ fontSize: props.iconSize }}
                />
                {props.showLabel && (
                    <span className={isEncompass ? styles.labelEncompass : styles.labelGeotab} style={{ fontSize: props.labelSize }}>
                        {flaggedByUsers && flaggedByUsers.length > 0 ? 'Flagged' : 'Unflagged'}
                    </span>
                )}
            </button>
        </div>
    );
};

export default VideoEventFlagButton;
